import { render, staticRenderFns } from "./PmpRecordEvaluatePage.vue?vue&type=template&id=51d0eb23&scoped=true&"
import script from "./PmpRecordEvaluatePage.vue?vue&type=script&lang=js&"
export * from "./PmpRecordEvaluatePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d0eb23",
  null
  
)

export default component.exports